import { render, staticRenderFns } from "./normalGoods.vue?vue&type=template&id=5a500231&scoped=true"
import script from "./normalGoods.vue?vue&type=script&lang=js"
export * from "./normalGoods.vue?vue&type=script&lang=js"
import style0 from "./normalGoods.vue?vue&type=style&index=0&id=5a500231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a500231",
  null
  
)

export default component.exports